import { formatUrl, handleApiRequest } from "@cpj-ai/panel-npm-package";
import {
  AuthAccountContactTypeChoices,
  UpdateOrganizationInformationMutation,
  UpdateOrganizationInformationMutationVariables,
  useUpdateOrganizationInformationMutation,
} from "@graphql/generated";
import { useCallback } from "react";
import toast from "react-hot-toast";
import { ICompanyInformationFormData } from "../formConfig";
import { OrganizationInformationAndCredentials } from "./useOrganizationInformationFormData";

export const useOrganizationInformationSubmit = (
  selectedOrganization: OrganizationInformationAndCredentials | null,
) => {
  const [updateProfile, { loading }] = useUpdateOrganizationInformationMutation();

  const handleSaveProfile = useCallback(
    async (data: ICompanyInformationFormData) => {
      if (!selectedOrganization?.id) {
        toast.error("Please select an organization");
        return;
      }

      const variables = {
        ...data,
        organizationId: selectedOrganization.id,
        city: typeof data.city === "string" ? data.city : data.city?.node?.id,
        businessType: typeof data.businessType === "string" ? data.businessType : data.businessType?.value,
        industry: typeof data.industry === "string" ? data.industry : data.industry?.node?.id,
        type: typeof data.type === "string" ? data.type : data.type?.value,
        size: typeof data.size === "string" ? data.size : data.size?.value,
        contacts: [
          {
            type: AuthAccountContactTypeChoices.WEBSITE,
            value: formatUrl(data.website ?? ""),
            organizationId: selectedOrganization.id,
          },
          {
            type: AuthAccountContactTypeChoices.PHONE,
            value: data.contactNumber ?? "",
            organizationId: selectedOrganization.id,
          },
          {
            type: AuthAccountContactTypeChoices.ADDRESS,
            value: data.address ?? "",
            organizationId: selectedOrganization.id,
          },
        ].filter((item) => item.value && item.value !== ""),
      };

      await handleApiRequest<UpdateOrganizationInformationMutation, UpdateOrganizationInformationMutationVariables>({
        apiFunction: updateProfile,
        variables,
        componentName: "ProfileInformationForm",
        actionName: "updateProfile",
        successMessage: "Profile updated successfully",
        fallbackErrorMessage: "Failed to update profile",
        extraErrorContext: {
          organizationId: selectedOrganization.id,
        },
      });
    },
    [selectedOrganization?.id, updateProfile],
  );

  return { handleSaveProfile, loading };
};
